import { fundingGetters } from '@/store/routines'
import { companyGetters } from '@/store/modules/company/routines'

export default {
  [fundingGetters.FUNDING_APP_ID]: (state, getters) => {
    const currentCompany = getters[companyGetters.COMPANY_CURRENT]
    return currentCompany ? currentCompany.fundingApplicationId : null
  }
}
